export const DELIVERY_INSTRUCTION_WIDGET_TEST_IDS = {
    DELIVERY_INSTRUCTION_WIDGET_ID: "DELIVERY_INSTRUCTION_WIDGET",
    DELIVERY_INSTRUCTION_ITEM: "DELIVERY_INSTRUCTION_ITEM",
};
